import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private userRoles: string[] = []; // Cache user roles to avoid repeated API calls

  constructor(private msalService: MsalService) {}

  isAuthenticated(): boolean {
    return this.msalService.instance.getActiveAccount() !== null;
  }

  getUserEmail(): string | null {
    const account = this.msalService.instance.getActiveAccount();
    return account?.username || null; // Typically, the username field contains the user's email
  }


  async getUserRoles(): Promise<string[]> {
    if (this.userRoles.length > 0) {
      return this.userRoles; // Return cached roles if available
    }

    try {
      const account = this.msalService.instance.getActiveAccount();
      if (!account) {
        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          this.msalService.instance.setActiveAccount(accounts[0]);
        }
      }

      const tokenResponse = await lastValueFrom(
        this.msalService.acquireTokenSilent({
          scopes: ['api://ca01eee5-1780-40a4-9cf5-963c3a376b18/access_as_user'],
        })
      );

      const decodedToken = this.parseJwt(tokenResponse.accessToken);
      this.userRoles = decodedToken?.roles || [];

      return this.userRoles;
    } catch (error) {
      console.error('Error getting user roles:', error);
      return [];
    }
  }

  async isAdmin(): Promise<boolean> {
    const roles = await this.getUserRoles();
    return roles.includes('ROSAdmin');
  }

  private parseJwt(token: string): any {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      return JSON.parse(atob(base64));
    } catch (e) {
      return null;
    }
  }
}
